import { Field as FormikField, useFormikContext } from "formik";
import withFormikAwareClassName from "./withFormikAwareClassName";

const Field = withFormikAwareClassName(FormikField);
export default Field;
